/* =============================================================================
   Akademija Starfy - koledar neba
   =============================================================================
   Kaj je nocoj visoko in kaj boste v resnici videli.

   Visina se racuna, ne ugiba:

       H   = LST - RA                       (urni kot)
       sin(h) = sin(dec)sin(fi) + cos(dec)cos(fi)cos(H)
       az  iz atan2, merjen od severa proti vzhodu

   za fi = 46,05° (Ljubljana) in za 22. uro po lokalnem casu, ker je to ura,
   ob kateri vecina ljudi res stopi ven.

   Drugi del je pomembnejsi od prvega: ob vsakem objektu pise, KAJ SE V RESNICI
   VIDI pri danem premeru. Zacetnik, ki pricakuje Hubblovo sliko in dobi sivo
   liso, obicajno proda teleskop. Tisti, ki ve, da bo videl sivo liso, in jo
   nato najde sam, ostane.
   ========================================================================== */
(function () {
  "use strict";

  var NS = "http://www.w3.org/2000/svg";
  var LAT = 46.05, LON = 14.5;
  var D2R = Math.PI / 180, R2D = 180 / Math.PI;

  /* ra v urah, dec v stopinjah, min = najmanjsi smiseln premer v mm */
  var OBJEKTI = [
    { id: "m42", ime: "M42 · Orionova meglica", tip: "meglica", ra: 5.588, dec: -5.39, mag: 4.0, min: 60,
      kaj: "Najlepši objekt na nebu za začetnika. Že v majhnem teleskopu je vidna kot siva krilata megla s štirimi zvezdami Trapeza v sredini. Barve ne boste videli - oko jih pri tej svetlosti ne zazna, kamera pa jih ujame v nekaj minutah." },
    { id: "m45", ime: "M45 · Gostosevci (Plejade)", tip: "kopica", ra: 3.790, dec: 24.12, mag: 1.6, min: 0,
      kaj: "Lepši v daljnogledu kot v teleskopu - kopica je široka štiri polne Lune in v teleskop preprosto ne gre. Če imate samo daljnogled, je to objekt, zaradi katerega ga imate." },
    { id: "m31", ime: "M31 · Andromedina galaksija", tip: "galaksija", ra: 0.712, dec: 41.27, mag: 3.4, min: 0,
      kaj: "Najbolj oddaljena stvar, ki jo vidite s prostim očesom - 2,5 milijona svetlobnih let. V teleskopu je podolgovata svetla lisa s svetlejšim jedrom. Spiralnih krakov ne boste videli; za to je potrebna kamera." },
    { id: "dvojna", ime: "Dvojna kopica (NGC 869 in 884)", tip: "kopica", ra: 2.320, dec: 57.14, mag: 4.3, min: 50,
      kaj: "Dve kopici drug ob drugem v istem vidnem polju, obe polni zvezd. Eden redkih objektov, ki v teleskopu izgleda bolje kot na fotografiji." },
    { id: "m35", ime: "M35 · kopica v Dvojčkih", tip: "kopica", ra: 6.148, dec: 24.34, mag: 5.1, min: 60,
      kaj: "Široka razsuta kopica, ki se pri majhni povečavi razsuje v na stotine posameznih zvezd. Dober test, ali ste ostro izostrili." },
    { id: "m44", ime: "M44 · Jasli", tip: "kopica", ra: 8.670, dec: 19.67, mag: 3.7, min: 0,
      kaj: "S prostim očesom megličasta lisa, v daljnogledu pa razpade v kakih štirideset zvezd. Rimljani so po njeni vidljivosti napovedovali vreme." },
    { id: "m81", ime: "M81 in M82 · par galaksij", tip: "galaksija", ra: 9.926, dec: 69.07, mag: 6.9, min: 100,
      kaj: "Dve galaksiji v istem polju: ena okrogla, druga podolgovata kot cigara. Pri 100 mm sta dve bledi lisi, pri 200 mm dobi M82 vidno teksturo." },
    { id: "m51", ime: "M51 · Vrtinčasta galaksija", tip: "galaksija", ra: 13.498, dec: 47.20, mag: 8.4, min: 150,
      kaj: "Spiralna galaksija s spremljevalko. Krake boste zaslutili šele pri 200 mm in temnem nebu - iz mesta pričakujte samo dve megličasti lisi." },
    { id: "m13", ime: "M13 · kroglasta kopica v Herkulu", tip: "kopica", ra: 16.695, dec: 36.46, mag: 5.8, min: 80,
      kaj: "Pol milijona zvezd v krogli. Pri 80 mm meglena krogla, pri 150 mm se rob začne krojiti v posamezne zvezde, pri 250 mm je razsuta do jedra. Objekt, ki najbolj nagradi večji premer." },
    { id: "m57", ime: "M57 · Prstanasta meglica", tip: "meglica", ra: 18.893, dec: 33.03, mag: 8.8, min: 100,
      kaj: "Majhen dimni obroček, velik kot Jupiter. Presenetljivo lahko ga najdete, ker leži točno med dvema zvezdama Lire. Barve ni, oblika obroča pa je nedvoumna." },
    { id: "albireo", ime: "Albireo · dvojna zvezda", tip: "zvezda", ra: 19.512, dec: 27.96, mag: 3.1, min: 50,
      kaj: "Zlata in modra zvezda drug ob drugem. Edini objekt na tem seznamu, kjer barve res vidite - in najboljši dokaz, da majhen teleskop ni izguba." },
    { id: "m27", ime: "M27 · Meglica Ročka", tip: "meglica", ra: 19.994, dec: 22.72, mag: 7.4, min: 80,
      kaj: "Svetla planetarna meglica v obliki jabolčnega ogrizka. Ena redkih meglic, ki jo tudi mestno nebo prenese." },
    { id: "m15", ime: "M15 · kroglasta kopica v Pegazu", tip: "kopica", ra: 21.500, dec: 12.17, mag: 6.2, min: 80,
      kaj: "Gostejša in bolj strnjena od M13. Jedro je tako zbito, da ga tudi veliki teleskopi ne razkrojijo do konca." }
  ];


  /* Slika s pripisom. Oznaka "fotografija" ni okras: obe poglavji ucita, da
     skozi okular tega NE boste videli tako, in glosna slika brez te oznake bi
     to lekcijo tiho izpodbila. */
  function slikaHtml(kljuc) {
    var s = (window.STARFY_SLIKE || {})[String(kljuc).toUpperCase()];
    if (!s) return "";
    var lic = s.lu ? '<a href="' + s.lu + '" rel="nofollow noopener" target="_blank">' + s.l + "</a>" : s.l;
    return '<span class="ak-foto">' +
      '<img src="' + s.u + '" alt="" loading="lazy" decoding="async">' +
      '<span class="ak-foto-cap"><b>fotografija</b>, ne pogled skozi okular · ' +
      '<a href="' + s.v + '" rel="nofollow noopener" target="_blank">' + s.a + "</a> · " + lic +
      "</span></span>";
  }

  function el(tag, attrs, parent) {
    var n = document.createElementNS(NS, tag);
    for (var k in attrs) n.setAttribute(k, attrs[k]);
    if (parent) parent.appendChild(n);
    return n;
  }

  function julianDay(y, mo, d, hUT) {
    if (mo <= 2) { y -= 1; mo += 12; }
    var A = Math.floor(y / 100), B = 2 - A + Math.floor(A / 4);
    return Math.floor(365.25 * (y + 4716)) + Math.floor(30.6001 * (mo + 1)) + d + B - 1524.5 + hUT / 24;
  }
  function lstDeg(y, mo, d, hLocal, poletni) {
    var jd = julianDay(y, mo, d, hLocal - (poletni ? 2 : 1));
    var T = (jd - 2451545.0) / 36525;
    var gmst = 280.46061837 + 360.98564736629 * (jd - 2451545.0) + 0.000387933 * T * T;
    return ((gmst + LON) % 360 + 360) % 360;
  }

  /* Visina in azimut iz urnega kota in deklinacije. */
  function altAz(o, lst) {
    var H = ((lst - o.ra * 15) % 360 + 360) % 360;
    var Hr = H * D2R, dr = o.dec * D2R, fr = LAT * D2R;
    var sinAlt = Math.sin(dr) * Math.sin(fr) + Math.cos(dr) * Math.cos(fr) * Math.cos(Hr);
    var alt = Math.asin(Math.max(-1, Math.min(1, sinAlt))) * R2D;
    var az = Math.atan2(-Math.cos(dr) * Math.sin(Hr),
      Math.sin(dr) * Math.cos(fr) - Math.cos(dr) * Math.sin(fr) * Math.cos(Hr)) * R2D;
    az = (az + 360) % 360;
    return { alt: alt, az: az };
  }

  var host = document.querySelector("[data-ak-nebo]");
  if (!host) return;

  var svg = host.querySelector("svg");
  var inMonth = host.querySelector("[data-in-month]");
  var inAper = host.querySelector("[data-in-aper]");
  var outMonth = host.querySelector("[data-out-month]");
  var outAper = host.querySelector("[data-out-aper]");
  var list = host.querySelector("[data-out-list]");

  // Dva seznama, ker slovenscina rodilnika ne dela z odrezano koncnico:
  // "januarja" minus "a" da "januarj", "marca" pa "marc". Imenovalnik za
  // drsnik, rodilnik za datum - oboje zapisano, nic ugibanja.
  var MESEC_IME = ["januar", "februar", "marec", "april", "maj", "junij",
    "julij", "avgust", "september", "oktober", "november", "december"];
  var MESEC_RODILNIK = ["januarja", "februarja", "marca", "aprila", "maja", "junija",
    "julija", "avgusta", "septembra", "oktobra", "novembra", "decembra"];
  var W = 620, H = 260, PAD = 34;

  function draw() {
    var m = +inMonth.value;
    var aper = +inAper.value;
    outMonth.textContent = MESEC_IME[m - 1];
    outAper.textContent = aper + " mm";

    var poletni = m >= 4 && m <= 10;
    var lst = lstDeg(2026, m, 15, 22, poletni);

    while (svg.firstChild) svg.removeChild(svg.firstChild);
    svg.setAttribute("viewBox", "0 0 " + W + " " + H);
    el("rect", { x: 0, y: 0, width: W, height: H, fill: "#040810", rx: 12 }, svg);

    // obzorje in visinske crte
    var y0 = H - PAD;
    el("line", { x1: PAD, y1: y0, x2: W - PAD, y2: y0, stroke: "#3c5478", "stroke-width": "1.5" }, svg);
    [30, 60].forEach(function (a) {
      var y = y0 - (a / 90) * (y0 - 18);
      el("line", { x1: PAD, y1: y, x2: W - PAD, y2: y, stroke: "#1b2b47", "stroke-width": "1", "stroke-dasharray": "3 6" }, svg);
      el("text", { x: PAD - 6, y: y + 4, "text-anchor": "end", fill: "#3c5478", "font-size": "10" }, svg).textContent = a + "°";
    });
    ["S", "V", "J", "Z", "S"].forEach(function (c, i) {
      var x = PAD + (i / 4) * (W - 2 * PAD);
      el("text", { x: x, y: H - 12, "text-anchor": "middle", fill: "#9fb0c9", "font-size": "12", "font-weight": "600" }, svg).textContent = c;
    });

    var vidni = [];
    OBJEKTI.forEach(function (o) {
      var p = altAz(o, lst);
      if (p.alt < 8) return;                       // pod 8 stopinjami je zrak preveden
      vidni.push({ o: o, alt: p.alt, az: p.az });
      var x = PAD + (p.az / 360) * (W - 2 * PAD);
      var y = y0 - (p.alt / 90) * (y0 - 18);
      var dosegljiv = aper >= o.min;
      el("circle", { cx: x, cy: y, r: dosegljiv ? 5 : 3.5,
        fill: dosegljiv ? "#ffe9a8" : "#41597f",
        stroke: dosegljiv ? "#ffd08a" : "none", "stroke-width": "1.4" }, svg);
      el("text", { x: x, y: y - 11, "text-anchor": "middle",
        fill: dosegljiv ? "#ffe9a8" : "#5c7398", "font-size": "10" }, svg)
        .textContent = o.ime.split("·")[0].trim();
    });

    el("text", { x: W / 2, y: 16, "text-anchor": "middle", fill: "#9fb0c9", "font-size": "11" }, svg)
      .textContent = "15. " + MESEC_RODILNIK[m - 1] + " ob 22. uri · " + vidni.length + " objektov nad obzorjem";

    // seznam po visini, ker je visoko = skozi manj zraka = ostreje
    vidni.sort(function (a, b) { return b.alt - a.alt; });
    list.innerHTML = vidni.map(function (v) {
      var o = v.o, ok = aper >= o.min;
      return '<li class="ak-obj' + (ok ? " is-ok" : "") + '">' +
        '<span class="ak-obj-alt">' + Math.round(v.alt) + "°</span>" +
        slikaHtml(o.id) +
        '<span class="ak-obj-body"><b>' + o.ime + "</b>" +
          '<em>' + o.kaj + "</em>" +
          '<span class="ak-obj-meta">' + o.tip + " · sij " + String(o.mag).replace(".", ",") +
          " · " + (o.min === 0 ? "vidno že z daljnogledom" : "od " + o.min + " mm naprej") + "</span>" +
        "</span>" +
        '<span class="ak-obj-flag">' + (ok ? "dosegljivo" : "premajhen premer") + "</span></li>";
    }).join("");
  }

  inMonth.addEventListener("input", draw);
  inAper.addEventListener("input", draw);
  draw();
})();
